import CasinoOutlinedIcon from "@mui/icons-material/CasinoOutlined";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import SystemButton from "@/ui/SystemButton/SystemButton";

type Props = {
	onSurprise: () => void;
	onReset: () => void;
	/** A saved design exists, so Reset removes it (and asks first). */
	hasSavedDesign: boolean;
	surpriseDisabled: boolean;
	resetDisabled: boolean;
	isResetting: boolean;
};

/** Surprise me and Reset, at the start of the Studio's action row. */
export const AnnieStudioTools: FC<Props> = ({ onSurprise, onReset, hasSavedDesign, surpriseDisabled, resetDisabled, isResetting }) => {
	const { t } = useTranslation();
	return (
		<>
			<SystemButton
				buttonVariant="secondary"
				size="compact"
				noFullWidthMobile
				leadingIcon={<CasinoOutlinedIcon fontSize="small" />}
				onClick={onSurprise}
				disabled={surpriseDisabled}
				data-testid="annie-studio-surprise"
			>
				{t("annie.studio.surprise")}
			</SystemButton>
			<SystemButton
				buttonVariant="borderless"
				size="compact"
				noFullWidthMobile
				onClick={onReset}
				loading={isResetting}
				disabled={resetDisabled}
				tooltip={t(hasSavedDesign ? "annie.studio.reset.tooltip" : "annie.studio.reset.tooltip_draft")}
				data-testid="annie-studio-reset"
			>
				{t("annie.studio.reset")}
			</SystemButton>
		</>
	);
};
